import { getNodeEnvVariable } from './getNodeFlag';
import { getViteEnvVariable } from './getViteFlag';

export function isFeatureEnabled(flagName: string): boolean {
  const flag = flagName.startsWith('VITE_')
    ? getViteEnvVariable(flagName)
    : getNodeEnvVariable(flagName);

  return flag === 'true';
}
